import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DisabledTrees } from "../../../../Constant";
import TreeView, { flattenTree } from "react-accessible-treeview";
import { ArrowIcon, CheckBoxIcon } from "../BasicTree";
import { DISABLE_TREE, TREE_VIEW } from "../../../../Data/Bonus Ui/TreeView";

const DisabledTree = () => {
  const disableTreeData = flattenTree(TREE_VIEW);

  return (
    <Card>
      <CommonCardHeader title={DisabledTrees} span={DISABLE_TREE} />
      <CardBody>
        <div className="disabled-container">
          <div className="checkbox">
            <TreeView data={disableTreeData} aria-label="Checkbox tree" multiSelect propagateSelect propagateSelectUpwards defaultDisabledIds={[2, 3, 4, 5]} togglableSelect expandedIds={[1,2,6,10]} nodeRenderer={({ element, isBranch, isExpanded, isSelected, isDisabled, isHalfSelected, getNodeProps, level, handleSelect, handleExpand }) => {
                return (
                  <div {...getNodeProps({ onClick: handleExpand })} style={{ marginLeft: 40 * (level - 1), opacity: isDisabled ? 0.5 : 1,marginTop:5 }}>
                    {isBranch && <ArrowIcon isOpen={isExpanded} />}<CheckBoxIcon className="checkbox-icon " onClick={(e: any) => { handleSelect(e); e.stopPropagation(); }} variant={isHalfSelected ? "some" : isSelected ? "all" : "none"} /><span className="name">{element.name}</span>
                    </div>
                );
              }}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DisabledTree;
